import React from "react";
import "./BlogTemplate.css"; // Make sure this matches your CSS file name

const BlogTemplate = ({ 
  bannerTitle, 
  children 
}) => {
  return (
    <>
      {/* Standardized Top Banner */}
      <section className="blog-banner">
        <h1 className="banner-title">{bannerTitle}</h1>
      </section>

      {/* The unique content of each blog post is injected here */}
      <main className="blog-content-wrapper">
        {children}
      </main>
    </>
  );
};

export default BlogTemplate;
